// extracted by css-extract-rspack-plugin
export default {"BankAccountReviewSection":"sputnik__BankAccountReviewSection__T4OZo","bankAccountReviewSection":"sputnik__BankAccountReviewSection__T4OZo"};